import { z, type ZodType } from 'zod'

export interface PageParams {
  page?: number
  pageSize?: number
}

/** What every list endpoint answers: one page of items and where it sits in the whole. */
export interface Paged<T> {
  items: T[]
  page: number
  pageSize: number
  totalCount: number
}

export const pagedSchema = <T>(item: ZodType<T>): ZodType<Paged<T>> =>
  z.object({ items: z.array(item), page: z.number(), pageSize: z.number(), totalCount: z.number() }) as unknown as ZodType<Paged<T>>

/** The largest page the backend allows. */
export const MAX_PAGE_SIZE = 100
